function map() {
    'use strict';
    var mapCenter, marker, addMarkers, addAllMarkers, map, infoWindows, infowindow, mainMarker;

    function initialize() {
        var div = $('.main-map .gmaps'),
            lat = markers['main']['lat'],
            lng = markers['main']['lng'],
            mainIcon = {
                url: markers['main']['pin'], // url
                size: new google.maps.Size(185, 160), // size
                anchor: new google.maps.Point(0, 100),
            },
            nextTrigger = $('.legend .legend__wrapper');

        mapCenter = new google.maps.LatLng(lat, lng);

        var mapOptions = {
            zoom: 14,
            maxZoom: 17,
            panControl: false,
            rotateControl: false,
            scaleControl: false,
            mapTypeControl: false,
            streetViewControl: false,
            scrollwheel: false,
            fullscreenControl: false,
            zoomControl: false,
            zoomControlOptions: {
                position: google.maps.ControlPosition.LEFT_BOTTOM
            },
            styles: [
                {
                    "featureType": "administrative",
                    "elementType": "labels.text.fill",
                    "stylers": [
                        {
                            "color": "#8a8a8a"
                        },
                        {
                            "visibility": "on"
                        }
                    ]
                },
                {
                    "featureType": "administrative",
                    "elementType": "labels.icon",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "administrative.province",
                    "elementType": "geometry.stroke",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "landscape",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "lightness": "0"
                        },
                        {
                            "saturation": "0"
                        },
                        {
                            "color": "#f4edef"
                        },
                        {
                            "gamma": "1"
                        }
                    ]
                },
                {
                    "featureType": "landscape.man_made",
                    "elementType": "all",
                    "stylers": [
                        {
                            "lightness": "-3"
                        },
                        {
                            "gamma": "1.00"
                        }
                    ]
                },
                {
                    "featureType": "landscape.natural.landcover",
                    "elementType": "geometry.fill",
                    "stylers": [
                        {
                            "visibility": "on"
                        }
                    ]
                },
                {
                    "featureType": "landscape.natural.terrain",
                    "elementType": "all",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "landscape.natural.terrain",
                    "elementType": "geometry.fill",
                    "stylers": [
                        {
                            "visibility": "on"
                        }
                    ]
                },
                {
                    "featureType": "poi",
                    "elementType": "all",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "poi",
                    "elementType": "labels.text.fill",
                    "stylers": [
                        {
                            "visibility": "on"
                        },
                        {
                            "color": "#ac997c"
                        }
                    ]
                },
                {
                    "featureType": "poi.park",
                    "elementType": "geometry.fill",
                    "stylers": [
                        {
                            "color": "#e7dbe2"
                        },
                        {
                            "visibility": "on"
                        }
                    ]
                },
                {
                    "featureType": "road",
                    "elementType": "all",
                    "stylers": [
                        {
                            "saturation": -100
                        },
                        {
                            "lightness": 45
                        },
                        {
                            "visibility": "simplified"
                        }
                    ]
                },
                {
                    "featureType": "road.highway",
                    "elementType": "all",
                    "stylers": [
                        {
                            "visibility": "simplified"
                        }
                    ]
                },
                {
                    "featureType": "road.highway",
                    "elementType": "geometry.fill",
                    "stylers": [
                        {
                            "color": "#91889f"
                        },
                        {
                            "visibility": "simplified"
                        }
                    ]
                },
                {
                    "featureType": "road.highway",
                    "elementType": "labels.text",
                    "stylers": [
                        {
                            "color": "#595959"
                        }
                    ]
                },
                {
                    "featureType": "road.arterial",
                    "elementType": "labels.text.fill",
                    "stylers": [
                        {
                            "color": "#919191"
                        }
                    ]
                },
                {
                    "featureType": "road.arterial",
                    "elementType": "labels.icon",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "road.local",
                    "elementType": "labels.text.fill",
                    "stylers": [
                        {
                            "visibility": "on"
                        },
                        {
                            "color": "#919191"
                        }
                    ]
                },
                {
                    "featureType": "transit",
                    "elementType": "all",
                    "stylers": [
                        {
                            "visibility": "simplified"
                        }
                    ]
                },
                {
                    "featureType": "transit.station.airport",
                    "elementType": "all",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "transit.station.airport",
                    "elementType": "labels.icon",
                    "stylers": [
                        {
                            "hue": "#0a00ff"
                        },
                        {
                            "saturation": "-77"
                        },
                        {
                            "gamma": "0.57"
                        },
                        {
                            "lightness": "0"
                        }
                    ]
                },
                {
                    "featureType": "transit.station.rail",
                    "elementType": "all",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "transit.station.rail",
                    "elementType": "labels.text.fill",
                    "stylers": [
                        {
                            "color": "#43321e"
                        }
                    ]
                },
                {
                    "featureType": "transit.station.rail",
                    "elementType": "labels.icon",
                    "stylers": [
                        {
                            "hue": "#ff6c00"
                        },
                        {
                            "lightness": "4"
                        },
                        {
                            "gamma": "0.75"
                        },
                        {
                            "saturation": "-68"
                        }
                    ]
                },
                {
                    "featureType": "water",
                    "elementType": "all",
                    "stylers": [
                        {
                            "color": "#eaf6f8"
                        },
                        {
                            "visibility": "on"
                        }
                    ]
                },
                {
                    "featureType": "water",
                    "elementType": "geometry.fill",
                    "stylers": [
                        {
                            "color": "#c7eced"
                        }
                    ]
                },
                {
                    "featureType": "water",
                    "elementType": "labels.text.fill",
                    "stylers": [
                        {
                            "lightness": "-49"
                        },
                        {
                            "saturation": "-53"
                        },
                        {
                            "gamma": "0.79"
                        }
                    ]
                }
            ]
        };

        map = new google.maps.Map(div[0], mapOptions);
        google.maps.event.trigger(map, 'resize');
        center();
        // mapOffset();

        mainMarker = new google.maps.Marker({
            position: new google.maps.LatLng(lat, lng),
            map: map,
            icon: mainIcon,
            zIndex: 1
        });

        function setMarkers(group) {

            if (typeof group === "undefined") {
                group = null;
            }

            if (addAllMarkers) {
                for (var x = 0; x < addAllMarkers.length; x++) {
                    addAllMarkers[x].setMap(null);
                }
            } else {
                addAllMarkers = [];
            }


            addAllMarkers = [];
            addMarkers = [];
            infoWindows = {};

            var maxMarkers = 3;

            if (group && typeof markers['additional'][group] !== 'undefined') {
                addMarkers[group] = markers['additional'][group];
                maxMarkers = markers['additional'][group]['pins'].length;
            } else {
                addMarkers = markers['additional'];
            }
            for (var key in addMarkers) {

                if (addMarkers.hasOwnProperty(key) && addMarkers[key]['pins'].length > 0) {

                    var pins = addMarkers[key]['pins'];

                    var icon = {
                        url: addMarkers[key]['icon'], // url
                        scaledSize: new google.maps.Size(40, 50), // scaled size
                        anchor: new google.maps.Point(30, 30)
                    };

                    maxMarkers = pins.length;

                    infoWindows[key] = {};

                    for (var b = 0; b < maxMarkers; b++) {
                        infowindow = new google.maps.InfoWindow({
                            content: '<div class="info-window-wrap">' + '<div class="top">' + '<span class="info">' + pins[b]['info'] + '</span>' + '</div>' + '<div class="bottom">' + '<span>' + pins[b]['foot'] + '</span>' + '</div>' + '</div>' + '<div class="clip-path"><div class="path"></div> ' + '</div>',
                            pixelOffset: new google.maps.Size(0, 30)
                        });

                        marker = new google.maps.Marker({
                            position: new google.maps.LatLng(pins[b]['lat'], pins[b]['lng']),
                            map: map,
                            icon: icon,
                            zIndex: 5,
                            animation: google.maps.Animation.DROP
                        });

                        marker.customData = {};
                        marker.customData.group = key;
                        marker.customData.index = b;
                        marker.customData.icon = addMarkers[key]['icon'];
                        marker.customData.iconHover = addMarkers[key]['icon_hover'];

                        addAllMarkers.push(marker);

                        infoWindows[key][b] = {};
                        infoWindows[key][b] = infowindow;
                    };
                }
            }
            for (var c = 0; c < addAllMarkers.length; c++) {

                addAllMarkers[c].addListener('mouseover', function (e) {

                    for (var b = 0; b < addAllMarkers.length; b++) {
                        infoWindows[addAllMarkers[b].customData.group][addAllMarkers[b].customData.index].close();
                    }

                    infoWindows[this.customData.group][this.customData.index].open(map, this);

                    setTimeout(function () {
                        $('.gm-style-iw').addClass('active');
                    }, 100)


                    $('.gm-style-iw').parent().css({"pointer-events": "none"});

                });

                addAllMarkers[c].addListener('click', function (e) {

                    for (var b = 0; b < addAllMarkers.length; b++) {
                        infoWindows[addAllMarkers[b].customData.group][addAllMarkers[b].customData.index].close();
                    }

                    infoWindows[this.customData.group][this.customData.index].open(map, this);

                    setTimeout(function () {
                        $('.gm-style-iw').addClass('active');
                    }, 100)


                    $('.gm-style-iw').parent().css({"pointer-events": "none"});

                });

                addAllMarkers[c].addListener('mouseout', function (e) {

                    setTimeout(function () {
                        $('.gm-style-iw').removeClass('active');
                    }, 100)

                    $('.gm-style-iw').on('transitionend webkitTransitionEnd oTransitionEnd', function () {
                        if(typeof this.customData.group !== 'undefined') {
                            infoWindows[this.customData.group][this.customData.index].close();
                        }
                    });

                    $('.gm-style-iw').parent().css({"pointer-events" : "none"});

                });

                google.maps.event.addListener(map, "click", function(event) {
                    for (var b = 0; b < addAllMarkers.length; b++) {
                        infoWindows[addAllMarkers[b].customData.group][addAllMarkers[b].customData.index].close();
                    }
                });

            }
        };


        google.maps.event.addDomListener(window, 'resize', center());


        $('.legend .legend__wrapper .legend__item').on('click', function () {

            var item = $(this);

            var legendWidth = $('.main-map  .legend').outerWidth() + 145;

            if (item.hasClass('active')) {

                item.removeClass('active');

                setMarkers();

                var bounds = new google.maps.LatLngBounds();

                bounds.extend(marker.getPosition());

                for (var i = 0; i < addMarkers[item.data('target')]['pins'].length; i++) {
                    var myLatLng = new google.maps.LatLng( addMarkers[item.data('target')]['pins'][i]['lat'], addMarkers[item.data('target')]['pins'][i]['lng']);
                    bounds.extend(myLatLng);
                }

                //center the map to the geometric center of all markers
                map.fitBounds(bounds, {top:300,right:30,left:legendWidth,bottom:50});
                var listener = google.maps.event.addListener(map, "idle", function() {

                    if (map.getZoom() > 16) map.setZoom(13);
                    google.maps.event.removeListener(listener);
                });

                // map.setCenter(mapCenter);

            } else {

                item.siblings().removeClass('active');

                item.addClass('active');

                setMarkers(item.data('target'));

                var bounds = new google.maps.LatLngBounds();

                bounds.extend(marker.getPosition());
                bounds.extend(mainMarker.getPosition());

                for (var i = 0; i < addMarkers[item.data('target')]['pins'].length; i++) {
                    var myLatLng = new google.maps.LatLng( addMarkers[item.data('target')]['pins'][i]['lat'], addMarkers[item.data('target')]['pins'][i]['lng']);
                    bounds.extend(myLatLng);
                }

                //center the map to the geometric center of all markers
                map.fitBounds(bounds, {top:300,right:30,left:legendWidth,bottom:200});
                // map.setCenter(mapCenter);


            }
        });
        setTimeout(function(){
            $('.main-map .gmaps').addClass('active');
            setMarkers();
            $('.main-map .legend').addClass('active');
        },300)
    }

    function center() {
        map.setCenter(mapCenter);
    }

    // function mapOffset() {
    //     if (window.matchMedia("(max-width: 768px)").matches) {
    //         map.panBy(0, -100);
    //     } else {
    //         map.panBy(-100, 80);
    //     }
    // }

    if ($('.main-map .gmaps').length > 0) {
        google.maps.event.addDomListener(window, 'load', initialize)
    }
}

map();